import { filterCapitalize } from "@/filters/capitalize";
import i18n from "@/plugins/i18n";

export interface ConfirmModelInterface {
  content: string;
  title: string;
  customButtons: ConfirmCustomButton[] | undefined | null;
  width?: undefined | string;
}

export interface ConfirmCustomButton {
  value: unknown;
  text: string;
  color: string | null | undefined;
  outlined?: boolean | undefined;
  insertSpace?: boolean | undefined;
}

export class ConfirmModel implements ConfirmModelInterface {
  content!: string;
  title!: string;
  customButtons: ConfirmCustomButton[] | undefined | null = null;
  width?: undefined | string;
  keepDuringPopState?: undefined | boolean = false;
  type?: ConfirmModelType;
  object?: unknown | undefined;
  constructor(
    content: string,
    title = "",
    customButtons: Array<ConfirmCustomButton> | null = null,
    width: undefined | string = undefined,
    keepDuringPopState: undefined | boolean = false,
    type: ConfirmModelType = undefined,
    object: unknown | undefined = undefined
  ) {
    this.content = content;
    this.title = title;
    this.customButtons = customButtons;
    this.width = width;
    this.keepDuringPopState = keepDuringPopState;
    this.type = type;
    this.object = object;
  }
  static confirmBoolFromContent(content: string): ConfirmModel {
    return new ConfirmModel(content, filterCapitalize(i18n.t("warning")), [
      {
        text: filterCapitalize(i18n.t("cancel")),
        color: "warning",
        value: false,
        outlined: true,
      },
      {
        text: filterCapitalize(i18n.t("confirm")),
        color: "warning",
        value: true,
      },
    ]);
  }
}

export type ConfirmModelType = "cost-document-popup-table" | "cost-document-virtual-popup-table" | undefined;
